import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post, DeserializeVoid } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class AtelierUnassignTourControllerRequestService {
  private static BASE_URL = '/atelier/unassignTour';
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      AtelierUnassignTourControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public unassignTour(tourId: number): Promise<void> {
    return this.post(`/${tourId}`, null, DeserializeVoid).toPromise();
  }
}
